import React, { useEffect, useState } from 'react'
import { compose } from 'recompose'
import { Container, Grid, Paper, Button } from '@material-ui/core'
import Warning from '@material-ui/icons/Warning'
import Typography from '@material-ui/core/Typography'
import StyledWrapper from '../../../components/StyledWrapper'
import { withRouter } from 'react-router'
import { injectIntl, FormattedDate } from 'react-intl'
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import * as cookies from '../../../utilties/cookies'

import { connect, shallowEqual, useSelector, useDispatch } from 'react-redux'
import Logo from '../../../assets/logo'
import history from '../../../utilties/history'

import { fetchTerm, fetchTerms, refreshCurrentCase, getCase, acceptCircleTerms } from '../../../redux/actions'
import { termSelector, circleIdSelector, thirdPartyTermsSelector, caseIdSelector } from '../../../redux/selectors'
import FormCheckBox from '../../../components/FormCheckBox'
import { reduxForm, formValueSelector } from 'redux-form'
import locale2 from 'locale2'
import translations from '../../../utilties/languages/locales'

const getLocale = () => {
	let locale = 'en';
	let localeCookie = cookies.get('languageAbbreviation');

	if (localeCookie) {
		locale = localeCookie;
	}
	else if (locale2) {
		locale = locale2.substring(0, 5)
		if (locale !== 'en-GB') {
			locale = locale2.substring(0, 2)
		}
	}

	if (!translations[locale]) {
		locale = 'en'
	}

	return locale;
}

const Term = ({
	intl,
	match,
	loadCase,
	circleId,
	loadTerms,
	circleTerms,
	handleSubmit,
	circleTermsField,
	acceptTerms
}) => {
	const dispatch = useDispatch()
	const caseId = useSelector(caseIdSelector, shallowEqual)
	const [patient] = useState(cookies.get('user'))

	useEffect(() => {
		if (patient) {
			loadCase(patient.id)
		}
	},
	[patient])

	useEffect(
		() => {
			if (circleId > 0 && patient?.id > 0) {
				loadTerms(circleId, getLocale())
			}
		},
		[circleId, patient]
	)
	

	const onSubmitForm = () => {
		if (!!circleTermsField) {
			acceptTerms(circleId, patient?.id)
		}
	}

	return (
		<StyledWrapper
			hidePagesMenu={true}
			canChangeLanguage={false}
			canChangePassword={false}
		>
			<Container maxWidth="lg"
				style={{
					paddingTop: '2em',
					paddingLeft: 'auto',
					paddingRight: 'auto'
				}}
			>
				<form data-testid="form-welcome" onSubmit={handleSubmit(onSubmitForm)}>
					<Paper style={{ padding: '4rem', marginBottom: '4rem' }} elevation={2}>
						<Grid
							container
							direction="column"
							alignItems="center"
							style={{
								paddingTop: '40px',
								paddingBottom: '30px'
							}}
						>
							<Grid
								item
								style={{
									paddingBottom: '30px'
								}}
							>
								<Logo />
							</Grid>
							<Grid
								item
								style={{
									paddingBottom: '10px'
								}}
							>
								<Typography
									style={{
										fontSize: '24px'
									}}
								>
									{intl.formatMessage({ id: 'app.terms.new' })}
								</Typography>
							</Grid>
							<Grid item>
								<Typography
									style={{
										fontSize: '18px'
									}}
								>
									{intl.formatMessage({ id: 'app.terms.reviewMessage' })}
								</Typography>
							</Grid>
						</Grid>
						<Grid container spacing={2} style={{ display: 'block' }}>
							<Grid item style={{ borderLeft: '5px solid #transparent', paddingTop: '10px', paddingBottom: '25px' }}>
								<div style={{ minHeight: '35vh', maxHeight: '35vh', overflowY: 'scroll', paddingLeft: '25px', border: '1px solid rgba(0, 0, 0, 0.42)', padding: '10px' }}>
									<Typography data-testid="thirdparty-terms-text" variant='caption'> <div dangerouslySetInnerHTML={{ __html: circleTerms }} /> </Typography>
								</div>
							</Grid>
						</Grid>
						<Grid
							container
							justifyContent="flex-start"
							style={{ paddingTop: '10px' }}
						>
							<Grid item>
								<FormCheckBox
									name='circleTermsField'
									data-testid="circle-terms-checkbox"
									label={intl.formatMessage({ id: 'app.welcome.shareWithProfessional' })}
									onch
								/>
							</Grid>
						</Grid>
						<Grid
							container
							justifyContent="flex-end"
							style={{ paddingTop: '10px' }}
						>
							<Grid item>
								<Button
									color="primary"
									variant="contained"
									disabled={!circleTermsField}
									type="submit"
								>
									{intl.formatMessage({ id: 'app.general.next' })}
								</Button>
							</Grid>
						</Grid>
					</Paper>
				</form>
			</Container>
		</StyledWrapper>
	)
}

const selector = formValueSelector('newTerms')

const mapStateToProps = (state, ownProps) => ({
	circleId: circleIdSelector(state),
	circleTerms: thirdPartyTermsSelector(state),
	circleTermsField: selector(state, 'circleTermsField')
})

const mapDispatchToProps = (dispatch, ownProps) => ({
	loadCase: (patientId) => dispatch(getCase(patientId)),
	loadTerms: (circleId, language) => dispatch(fetchTerms(circleId, language)),
	acceptTerms: (circleId, patientId) => dispatch(acceptCircleTerms(circleId, patientId))
})

const enhance = compose(
	connect(mapStateToProps, mapDispatchToProps),
	injectIntl,
	reduxForm({
		form: 'newTerms',
		touchOnChange: true,
		touchOnBlur: true,
		enableReinitialize: true
	}),
	withRouter
)

export default enhance(Term)
